/**
 * @file: description
 * @author:
 * @Date: 2020-03-31 10:40:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-04-09 19:48:58
 */
import React, { useState } from 'react';
import './FollowItem.less';
import { Link } from 'react-router-dom';
import { SearchItemCondition } from '@src/services';
import { openGroupOrTeamIndex } from '@src/utils';
import { bindActionCreators, Dispatch } from '@tkit/actions';
import { connect } from 'react-redux';
import { IRootState } from '@src/types';
import { message } from 'antd';
import { SFCAvatar, IconFont } from '../..';
import actions from '../../redux/actions';

export interface IFollowItemProps {
  data: SearchItemCondition;
  /** 控制是否打开新标签 */
  target: string;
  /** 当前的类型 */
  type: string;
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
};
const mapStateToProps = (state: IRootState) => ({});

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = StateProps & DispatchProps & IFollowItemProps;

const relationMap = {
  // 0: '加入',
  1: '退出', //成员
  2: '同意加入', //被邀请
  // 3: '加入', //被移除
  4: '审批中', //申请加入
  // 5: '加入', //申请被拒绝
  9: '退出' //圈主
};
export function FollowItem(props: Readonly<Props>) {
  const {
    data,
    target,
    type,
    actions: { userFollow, groupJoin, teamFollow }
  } = props;
  const {
    username,
    photo,
    attended,
    joined,
    follower,
    article,
    desc,
    typeName,
    id,
    isChecked,
    name
  } = data;
  /** 用户或者团队关注 */
  const [follow, setFollow] = useState(attended);
  /** 圈子加入退出 */
  const [join, setJoin] = useState(joined);
  const [relation, setRelation] = useState(data.relation || 0);

  /** 用户关注切换 */
  const userToggleFollow = () => {
    userFollow({
      params: { ifFollow: !follow, targetUser: username },
      callBack: res => {
        setFollow(!follow);
      }
    });
  };

  /** 圈子加入切换 */
  const groupToggleJoin = () => {
    relation !== 4 &&
      groupJoin({
        params: { groupId: id || 0, join: !join },
        callBack: res => {
          if (!isChecked) {
            setJoin(!join);
            message.success(`${!join ? '已加入圈子' : '已退出圈子'}`);
          } else {
            if (relation === 2) {
              message.success('成功加入圈子');
              setRelation(1);
            } else if (relation === 1) {
              message.success('已退出圈子');
              setRelation(3);
            } else {
              message.success('等待管理员审批');
              setRelation(4);
            }
          }
        }
      });
  };

  /** 团队关注切换 */
  const teamToggleFollow = () => {
    teamFollow({
      params: { teamId: id || 0, follow: !follow },
      callBack: res => {
        setFollow(!follow);
      }
    });
  };

  return (
    <div className="k-search-follow-item">
      <div className="item__lef">
        {type === 'USER' ? (
          <Link to={`/personal/${username}`} target={target}>
            <SFCAvatar className="pic" src={photo} />
          </Link>
        ) : (
          <SFCAvatar className="pic" src={photo} />
        )}
        <div className="content">
          <p className="content-name">
            {type === 'USER' ? (
              <Link to={`/personal/${username}`} target={target}>
                {name}
              </Link>
            ) : (
              <span onClick={() => openGroupOrTeamIndex(typeName, id)}>{name}</span>
            )}
            {type === 'USER' || type === 'TEAM'
              ? follow && <span className="status">已关注</span>
              : ((!isChecked && join) || (isChecked && (relation === 1 || relation === 9))) && (
                  <span className="status">已加入</span>
                )}
          </p>

          <div className="content-info">
            <IconFont type="icon-peo" className="icon-peo" />
            <span className="num">{follower}</span>个
            {type === 'USER' || type === 'TEAM' ? '粉丝' : '成员'}
            <span className="splite">|</span>
            <IconFont type="icon-article" className="icon-article" />
            <span className="num">{article}</span>
            篇文章
          </div>

          <p className="content-desc">{desc}</p>
        </div>
      </div>
      {type === 'USER' && (
        <button className={`follow ${follow ? 'followed' : ''}`} onClick={userToggleFollow}>
          {follow ? '取消关注' : '关注'}
        </button>
      )}
      {type === 'GROUP' && (
        <button
          className={`follow ${
            (!isChecked && join) || (isChecked && relationMap[relation]) ? 'followed' : ''
          }`}
          onClick={groupToggleJoin}
        >
          {!isChecked
            ? join
              ? '退出'
              : '加入'
            : relationMap[relation]
            ? relationMap[relation]
            : '加入'}
        </button>
      )}
      {type === 'TEAM' && (
        <button className={`follow ${follow ? 'followed' : ''}`} onClick={teamToggleFollow}>
          {follow ? '取消关注' : '关注'}
        </button>
      )}
    </div>
  );
}

export default connect<StateProps, DispatchProps>(mapStateToProps, mapDispatchToProps)(FollowItem);
